import React from 'react';

import AppProviders from '../../../app/providers/AppProviders';
import YowanShell from '../app/YowanShell';
import YowanRoutes from '../routes/YowanRoutes';
import '../styles/index.scss';

const YowanApp = () => {
  return (
    <AppProviders useAuth={false} themeDomain="yowan">
      <YowanShell>
        <YowanRoutes />
      </YowanShell>
    </AppProviders>
  );
};

export default YowanApp;
